import { JsonObject, JsonProperty } from 'json2typescript';

import { PublicDutiesInterface, PublicDutiesOption } from '../../../core';
import { PublicDutiesOptionAdapter } from '../../client/helpers/serializer/adapters/public-duties-option.adapter';
import { RelativeRelationship } from './relative-relationship';

@JsonObject('PublicDuties')
export class PublicDuties implements PublicDutiesInterface {
    private readonly MAX_RELATIONS = 5;

    @JsonProperty('IsImportantPublicDuties', Boolean, true)
    private _isImportant: boolean = undefined;

    @JsonProperty('ImportantPublicDuties', PublicDutiesOptionAdapter, true)
    private _importantFreeText: PublicDutiesOption = undefined;

    @JsonProperty('IsImportantPublicDutiesRelative', Boolean, true)
    private _isImportantRelative: boolean = undefined;

    @JsonProperty('RelativeRelationship', [RelativeRelationship], true)
    private _relativeRelationship: RelativeRelationship[] = undefined;

    get isImportant(): boolean {
        return this._isImportant;
    }

    set isImportant(value: boolean) {
        this._isImportant = value;

        if (!this._isImportant) {
            this._importantFreeText = undefined;
        }
    }

    get importantFreeText(): PublicDutiesOption {
        return this._importantFreeText;
    }

    set importantFreeText(value: PublicDutiesOption) {
        this._importantFreeText = value;
    }

    get isImportantRelative(): boolean {
        return this._isImportantRelative;
    }

    set isImportantRelative(value: boolean) {
        this._isImportantRelative = value;

        if (!this._isImportantRelative) {
            this._relativeRelationship = [];
        }
    }

    get relativeRelationship(): RelativeRelationship[] {
        if (!this._relativeRelationship) {
            this._relativeRelationship = [];
        }

        return this._relativeRelationship;
    }

    addRelationship(value: RelativeRelationship) {
        if (!this.relativeRelationship.find((it) => String(it.id) === String(value.id))) {
            this.relativeRelationship.push(value);
        }
    }

    updateRelationship(value: RelativeRelationship) {
        this.relativeRelationship.map((it, idx) => {
            if (String(it.id) === String(value.id)) {
                this.relativeRelationship[idx] = value;
            }
        });
    }

    removeRelationship(value: RelativeRelationship) {
        this.relativeRelationship.map((it, idx) => {
            if (String(it.id) === String(value.id)) {
                this.relativeRelationship.splice(idx, 1);
            }
        });
    }

    isComplete(): boolean {
        return (
            (this.isImportant ? !!this.importantFreeText : typeof this.isImportant === 'boolean') &&
            (this.isImportantRelative
                ? !this.relativeRelationship.some((relationship) => !relationship.isComplete())
                : typeof this.isImportantRelative === 'boolean')
        );
    }

    isFull(): boolean {
        return this.relativeRelationship && this.relativeRelationship.length >= this.MAX_RELATIONS;
    }
}
